import * as React from 'react';

import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from './components/ui/pagination.js';

export function DimePagination({ ...props }: Readonly<React.ComponentProps<typeof Pagination>>) {
  return <Pagination {...props} />;
}

export function DimePaginationContent({
  ...props
}: Readonly<React.ComponentProps<typeof PaginationContent>>) {
  return <PaginationContent {...props} />;
}

export function DimePaginationItem({
  ...props
}: Readonly<React.ComponentProps<typeof PaginationItem>>) {
  return <PaginationItem {...props} />;
}

export function DimePaginationLink({
  ...props
}: Readonly<React.ComponentProps<typeof PaginationLink>>) {
  return <PaginationLink {...props} />;
}

export function DimePaginationPrevious({
  ...props
}: Readonly<React.ComponentProps<typeof PaginationPrevious>>) {
  return <PaginationPrevious {...props} />;
}

export function DimePaginationNext({
  ...props
}: Readonly<React.ComponentProps<typeof PaginationNext>>) {
  return <PaginationNext {...props} />;
}

export function DimePaginationEllipsis({
  ...props
}: Readonly<React.ComponentProps<typeof PaginationEllipsis>>) {
  return <PaginationEllipsis {...props} />;
}
